import MultiStepListingForm from "@/components/listings/add/MultiStepListingForm";
import { useIsMobile } from "@/hooks/use-mobile";

const AddListing = () => {
  const isMobile = useIsMobile();

  return (
    <div className={`container mx-auto py-6 ${isMobile ? "px-4" : "px-6"}`}>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Add New Property</h1>
        <p className="text-gray-500 mt-1">
          Fill in the details below to create a new property listing. Complete
          each step before proceeding.
        </p>
      </div>

      <div
        className={`bg-white rounded-lg shadow-sm border border-gray-100 ${
          isMobile ? "p-4" : "p-6"
        }`}
      >
        <MultiStepListingForm />
      </div>
    </div>
  );
};

export default AddListing;
